import { render } from "./BreadcrumbBlogDetail.vue?vue&type=template&id=652ac842&scoped=true"
import script from "./BreadcrumbBlogDetail.vue?vue&type=script&lang=js"
export * from "./BreadcrumbBlogDetail.vue?vue&type=script&lang=js"

import "./BreadcrumbBlogDetail.vue?vue&type=style&index=0&id=652ac842&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652ac842"]])

export default __exports__